require('./../libs/jquery.steps');

//Import functions
const { isValidDate, isEmail } = require('./functions');
const { sendPDF } = require('./survey.pdf');

// Init global variable
var step = null;

/**
 * Init survey steps
 * @returns {boolean} true|false
 */
function initSurveySteps() {

	if ($('.wizard').length == 0) {

		step = $('.steps').steps({
			headerTag: 'h3',
			bodyTag: 'section',
			transitionEffect: 'slideLeft',
			stepsOrientation: 'vertical',
			enableKeyNavigation: false,
			onStepChanging: function (event, currentIndex, newIndex)
			{

				if (currentIndex == 0 || newIndex == 0) {
					$('#return-steps').addClass('hide');
				}

				if (newIndex < currentIndex) {
					$('html, body').animate({ scrollTop: $(document).find('section.current').offset().top - 200}, 'slow');
					if (newIndex != (step.steps('getTotalSteps') - 1)) {
						$('#next-steps').removeClass('hide');
						$('#next-steps').show();
						$('#save').addClass('hide');
						$('#save').hide();
					}
					return true;
				} else {
					if (validation(currentIndex, step.steps('getTotalSteps'))) {
						if (newIndex == 1) {
							$('#return-steps').removeClass('hide');
						}
						if (newIndex == (step.steps('getTotalSteps') - 1)) {
							$('#next-steps').addClass('hide');
							$('#next-steps').hide();
							$('#save').removeClass('hide');
							$('#save').show();
						}
						$('html, body').animate({ scrollTop: $(document).find('section.current').offset().top - 200}, 'slow');
						return true;
					}
				}
			}
		});
	}
}

/**
 * Validation survey form
 * @param {number} current_step current step
 * @param {number} total_steps of steps
 */
function validation(current_step, total_steps) {

	var not_empty = true;
	var scroll_to = $('.steps.wizard');

	switch (current_step) {
	case 0:
		$('#steps-uid-0-p-'+current_step).find('input[required]').each(function() {
			if ($(this).val() == '') {
				$(this).addClass('error').next('.error-text').first().text($(this).attr('data-required')).show();
				not_empty = false;
			} else {
				$(this).removeClass('error').next('.error-text').first().hide();
			}
		});
		
		if ($('input.error').length) {
			$('html, body').animate({ scrollTop: $(document).find('input.error').first().offset().top - 200}, 'slow');
			return not_empty;
		}

		if ($('#courriel').val() && !isEmail($('#courriel').val())) {
			$('#courriel').addClass('error').next('.error-text').first().text($('#courriel').attr('data-invalid')).show();
			scroll_to = $('#courriel');
			$('html, body').animate({ scrollTop: scroll_to.offset().top - 200}, 'slow');
			return false;
		} else {
			$('#courriel').removeClass('error').next('.error-text').first().hide();
		}

		var message = '';

		// Validate phone for the fee manager
		if ($('#telmobile').val() == '' && $('#telbureau').val() == '' && $('#teldomicile_patient').val() == '') {
			message += '\n - '+'Veuillez indiquer au moins un téléphone de contact du patient.';
			scroll_to = $('#teldomicile_patient');
			if (message != '') {
				alert(message);
				$('html, body').animate({ scrollTop: scroll_to.offset().top - 200}, 'slow');
				return false;
			}
		}

		// Validate date
		if ( ($('#annee').length > 0 && $('#annee').val() != '') && ($('#mois').length > 0 && $('#mois').val() != '') && ($('#jour').length > 0 && $('#jour').val() != '') ) {

			var d = new Date();
			var anneeA = d.getFullYear();
			var moisA = d.getMonth();
			var jourA = d.getDate();

			var userA = $('#annee').val();
			var userM = $('#mois').val();
			var userj = $('#jour').val();

			if (userA.length != 4 || userM.length != 2 || userj.length != 2) {
				message += '\n - ' + 'Veuillez indiquer une date de naissance valide (Exemple : 2000-02-02)';
			} else {
				var birth = userj + '/' + userM + '/' + userA;
				if (!isValidDate(birth, 'D/M/YYYY')) {
					message += '\n - ' + 'Veuillez indiquer une date de naissance valide (Exemple : 2000-02-02)';
				}
			}

			scroll_to = $('#annee');
			if (message != '') {
				alert(message);
				$('html, body').animate({ scrollTop: scroll_to.offset().top - 200}, 'slow');
				return false;
			}

		}

		if (!(anneeA-18 > userA) && !(anneeA-18 == userA && moisA > userM) && !(anneeA-18 == userA && moisA == userM && jourA >= userj)) {
			if ($('#parent').val() == '' && $('#tutor').val() == '') {
				message += '\n - ' + 'Vous avez moins de 18 ans, veuillez indiquer le nom du parent ou du tuteur.';
				scroll_to = $('#parent');
				if (message != '') {   
					alert(message);
					$('html, body').animate({ scrollTop: scroll_to.offset().top - 200}, 'slow');
					return false;
				}
			}
		}

		// Social number is not required
		if ($('#numeroassurance').length > 0 && $('#numeroassurance').val() != '') {

			var month_expiration = $('#month_expiration').val();
			var year_expiration = $('#year_expiration').val();

			var expiration = month_expiration + '/' + year_expiration;

			if (month_expiration == '' || year_expiration == '') {
				message += '\n - '+ 'Veuillez indiquer la date d\'expiration';
			} else if (year_expiration.length != 4 || month_expiration.length != 2 || !isValidDate(expiration, 'M/YYYY')) {
				message += '\n - '+ 'Veuillez indiquer une date d\'expiration valide (Exemple : 02-2000)';
			}
			scroll_to = $('#month_expiration');
			if (message != '') {
				alert(message);
				$('html, body').animate({ scrollTop: scroll_to.offset().top - 200}, 'slow');
				return false;
			}
			$('#expiration').val(expiration);

		}

		// Validate for one contact phone for the fee manager.
		if ($('input[name=lui_meme]:checked').val() == 'Non') {
			if ($('#responsable_telmobile').val() == '' && $('#responsable_telbureau').val() == '' && $('#responsable_teldomicile').val() == '') {
				message += '\n - ' + 'Veuillez indiquer au moins un téléphone de contact pour le responsable des honoraires.';
				scroll_to = $('#responsable_teldomicile');
				if (message != '') {
					alert(message);
					$('html, body').animate({ scrollTop: scroll_to.offset().top - 200}, 'slow');
					return false;
				}
			}
		}

		// Check if the person responsible exist or not
		if ($('input[name=lui_meme]:checked').val() == 'Non') {
			if ( $('#responsable_nom').val() == '' || $('#responsable_prenom').val() == '' || $('#responsable_adresse').val() == '' || $('#responsable_ville').val() == '' || $('#responsable_codepostal').val() == '') {
				message += '\n - ' + 'Veuillez indiquer toutes les informations du responsable des honoraires.';
				scroll_to = $('#responsable_nom');
				if (message != '') {
					alert(message);
					$('html, body').animate({ scrollTop: scroll_to.offset().top - 200}, 'slow');
					return false;
				}
			}
		}

		// Validation de la date de naissance (COVID-19)
		if ( ($('#year_birthday').length > 0 && $('#year_birthday').val() != '') && ($('#month_birthday').length > 0 && $('#month_birthday').val() != '') && ($('#day_birthday').length > 0 && $('#day_birthday').val() != '') ) {

			var year_birthday = $('#year_birthday').val();
			var month_birthday = $('#month_birthday').val();
			var day_birthday = $('#day_birthday').val();

			if (year_birthday.length != 4 || month_birthday.length != 2 || day_birthday.length != 2) {
				message += '\n - ' + 'Veuillez indiquer une date de naissance valide (Exemple : 2000-02-02)';
			} else {
				var birthday = day_birthday + '/' + month_birthday + '/' + year_birthday;
				if (!isValidDate(birthday, 'D/M/YYYY')) {
					message += '\n - ' + 'Veuillez indiquer une date de naissance valide (Exemple : 2000-02-02)';
				}
			}

			scroll_to = $('#year_birthday');
			if (message != '') {
				alert(message);
				$('html, body').animate({ scrollTop: scroll_to.offset().top - 200}, 'slow');
				return false;
			}

		}

		return true;

		/* eslint-disable no-unreachable */
		break;
		/* eslint-enable */

	case (total_steps - 1):
		if (!RadioValidator()) {
			alert('Veuillez répondre à toutes les questions');
			return false;
		}
			
		not_empty = true;
		scroll_to = $('.steps.wizard');
		$('#steps-uid-0-p-'+current_step).find('input[required]').each(function(){
			if(($(this).attr('type') == 'text' && $(this).val() == '') || ($(this).attr('type') == 'checkbox' && !$(this).is(':checked'))){
				$(this).addClass('error').nextAll('.error-text').first().text($(this).attr('data-required')).show();
				not_empty = false;
			}else{
				$(this).removeClass('error').nextAll('.error-text').first().hide();
			}
		});
		if($('input.error').length){
			$('html, body').animate({ scrollTop: $(document).find('input.error').first().offset().top - 200}, 'slow');
			return not_empty;
		}

		// Signature validation
		if( $('.sigPad').find('input#signature').val() === ''){
			$('.sigPad').find('.error-signature').addClass('show');
			return false;            
		} else {
			$('.sigPad').find('.error-signature').removeClass('show');
		}

		return true;
			
		/* eslint-disable no-unreachable */
		break;
		/* eslint-enable */
	
	default:
		if ( RadioValidator() ) {

			if ( !DateValidator() ) {
				alert('Veuillez insérer les dates');
				return false;
			}
	
		} else {
			alert('Veuillez répondre à toutes les questions');
			return false;
		}

		return true;

		/* eslint-disable no-unreachable */
		break;
		/* eslint-enable */

	}

}

function showCovidSection(age) {
	if(age > 5){
		$('div.groupe-age').addClass('hide');
		$('div.groupe-age[data-age="six_plus"]').removeClass('hide');
	}else{
		$('div.groupe-age').addClass('hide');
		$('div.groupe-age[data-age="cinq_moins"]').removeClass('hide');
	}
}

function validateFieldsByYear() {
	var d = new Date();
	var currentYear = d.getFullYear();
	var userA = '';
	var age = '';
	if ($('input[name="year_birthday"]').length > 0) {
		userA = $('#year_birthday').val();
		age = currentYear - userA;
		if ($('#groupe-age').length > 0) {
			//Show covid-19 sections
			showCovidSection(age);
		}
	} else {
		userA = $('#annee').val();
		age = currentYear - userA;

		// validate for croissance
		if (age >= 10 && age <= 14) {
			$('.croissance-wrapper').removeClass('hide').addClass('show');
			$('.croissance-wrapper input:radio').removeClass('no-check');
		} else {
			$('.croissance-wrapper').removeClass('show').addClass('hide');
			$('.croissance-wrapper input:radio').addClass('no-check');
		}

		// validate for 18 years
		if (age >= 18) {
			$('.mineur').closest('.wrapper-question').removeClass('hide');
			$('.mineur').closest('.wrapper-question').find('input:radio').removeClass('no-check');
		} else {
			$('.mineur').closest('.wrapper-question').addClass('hide');
			$('.mineur').closest('.wrapper-question').find('input:radio').addClass('no-check');
		}

		if ($('#groupe-age').length > 0) {
			//Show covid-19 sections
			showCovidSection(age);
		}
	}
}

function RadioValidator() {
	$('.wrapper-question').removeClass('notvalid');
	var ShowAlert = '';
	var AllFormElements = window.document.getElementById('survey-form').elements;

	for (var i = 0; i < AllFormElements.length; i++) {
		if (AllFormElements[i].type == 'radio' && $('#'+AllFormElements[i].id).closest('section.current').length) {
			var ThisRadio   = AllFormElements[i].name;
			var $ThisRadio  = $('input[name="'+ThisRadio+'"]');

			if (!$ThisRadio.hasClass('no-check')) {
				if ( ($('input[name="'+ThisRadio+'"]').closest('.groupe-age').length && $('input[name="'+ThisRadio+'"]').closest('.groupe-age').is(':visible')) || (!$('input[name="'+ThisRadio+'"]').closest('.groupe-age').length) ) {
					var ThisChecked = 'No';
					var AllRadioOptions = document.getElementsByName(ThisRadio);
					for (var x = 0; x < AllRadioOptions.length; x++) {
						if (AllRadioOptions[x].checked && ThisChecked == 'No') {
							ThisChecked = 'Yes';
							break;
						}
					}
					var AlreadySearched = ShowAlert.indexOf(ThisRadio);
					if (ThisChecked == 'No' && AlreadySearched == -1) {
						$('input[name="'+ThisRadio+'"]').closest('.wrapper-question').addClass('notvalid');
						ShowAlert = ShowAlert + ThisRadio + ' radio button must be answered\n';
					}
				}
			}
		}
	}

	if (ShowAlert == '') {
		// Checked value when mandatory is active
		var mandatory_type = ['oui', 'un peu', 'beaucoup'];
		$('input[type="radio"]').each(function() {
			if ( ($(this).closest('section.current').length && $(this).closest('.wrapper-question.mandatory').length) && (jQuery.inArray($(this).val().toLowerCase(), mandatory_type) !== -1) && ($(this).is(':checked') && $(this).closest('.wrapper-question.mandatory').find('textarea').val() == '')) {
				$(this).closest('.wrapper-question').addClass('notvalid');
				ShowAlert = 'Error !';
			}
		});
	}

	if ($('.notvalid').length) {
		$('html, body').animate({ scrollTop: $(document).find('.notvalid').first().offset().top - 200}, 'slow');
	}

	if (ShowAlert != '') {
		return false;
	}else {
		return true;
	}
}

function DateValidator() {

	$('.wrapper-question').removeClass('notvalid');
	var ShowAlert = '';

	// Checked value when mandatory_date is active
	var mandatory_type = ['oui'];
	$('input[type="radio"]').each(function() {
		if ( ($(this).closest('section.current').length && $(this).closest('.wrapper-question.mandatory_date').length) && $(this).is(':checked') && (jQuery.inArray($(this).val().toLowerCase(), mandatory_type) !== -1) && ($('input[name="'+$(this).attr('name')+'_date"]').length && $('input[name="'+$(this).attr('name')+'_date"]').val() == '') ) {
			$(this).closest('.wrapper-question').addClass('notvalid');
			ShowAlert = 'Error !';
		}
	});

	if ($('.notvalid').length) {
		$('html, body').animate({ scrollTop: $(document).find('.notvalid').first().offset().top - 200}, 'slow');
	}

	if (ShowAlert != '') {
		return false;
	} else {
		return true;
	}

}

jQuery(() => {

	// Return Steps button
	$(document).on('click', '#return-steps', function(e) {
		e.preventDefault();
		e.stopPropagation();
		step.steps('previous');
	});

	// Return Steps button
	$(document).on('click', '#next-steps', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('.steps').steps('next');
	});

	// Return Steps button
	$(document).on('click', '#save', function(e) {
		e.preventDefault();
		e.stopPropagation();
		if(validation(step.steps('getCurrentIndex'), step.steps('getTotalSteps'))) {
			sendPDF();
		}
	});

	validateFieldsByYear();

	$(document).on('change', 'input[name="annee"], input[name="year_birthday"]', function() {
		validateFieldsByYear();
	});

	$('textarea[maxlength]').on('keyup', function() {
	
		// Store the maxlength and value of the field.
		var maxlength = $(this).attr('maxlength');
		var val = $(this).val();

		// Trim the field if it has content over the maxlength.
		if (val.length > maxlength) {
			$(this).val(val.slice(0, maxlength));
		}
		
	});

	$(document).on('change', 'input[name="lui_meme"]', function() {
		if (this.value == 'Oui') {
			$('input[name^="responsable"]').prop('disabled', true);
			$('input[name^="responsable"]').prop('required', false);
		} else if (this.value == 'Non') {
			$('input[name^="responsable"]').prop('disabled', false);
			$('input[name^="responsable"]').prop('required', true);
			$('#responsable_telmobile').prop('required', false);
			$('#responsable_telbureau').prop('required', false);
			$('#responsable_teldomicile').prop('required', false);
			$('#responsable_poste').prop('required', false);
		}
	});

	$(document).on('change', 'input[name="sexe"]', function() {
		// validate for croissance
		if (this.value == 'femme') {
			$('.girl-wrapper').removeClass('hide').addClass('show');
			$('.girl-wrapper input:radio').removeClass('no-check');
		}else{
			$('.girl-wrapper').removeClass('show').addClass('hide');
			$('.girl-wrapper input:radio').addClass('no-check');
		}
	});

});

module.exports = {
	initSurveySteps,
	validateFieldsByYear
};
